/* @flow */

import React from 'react';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

const styles = {
  loader: {
    minHeight: '140px',
  },
};

const DeploymentLoader = () => (
  <Segment style={styles.loader}>
    <Dimmer active inverted>
      <Loader
        indeterminate
        size="big"
        content="Déploiement en production en cours..."
      />
    </Dimmer>
  </Segment>
);

export default DeploymentLoader;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Deployments/components/DeploymentLoader.js